<template>
  <div>
    <v-menu offset-y max-width="300px">
      <template #activator="{ on }">
        <v-list-item
          v-if="isSpacer(channel.channelName)"
          dense
          v-on="on"
          @dragover.native.prevent="onDragOver"
          @dragleave.native="onDragLeave"
          @drop.native.prevent="onDropClient"
        >
          <v-list-item-content>
            <v-list-item-title>
              <spacer :channelName="channel.channelName"></spacer>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          v-else
          dense
          v-on="on"
          :class="{ 'drop-hover': isDropHover }"
          @dragover.native.prevent="onDragOver"
          @dragleave.native="onDragLeave"
          @drop.native.prevent="onDropClient"
          :title="channelHoverTitle"
        >
          <v-list-item-avatar>
            <v-icon large>{{ channelIconName(channel) }}</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>
              {{ prettyChannelName(channel.channelName) }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>

      <v-list>
        <v-list-item @click="enterChannel">
          <v-list-item-action>
            <v-icon>arrow_forward</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Kanala Geç</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          :to="{
            name: 'channel-edit',
            params: { cid: channel.cid },
            query: { pid: channel.pid },
          }"
        >
          <v-list-item-action>
            <v-icon>edit</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Kanalı Düzenle</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          :to="{ name: 'permissions-channel', params: { cid: channel.cid } }"
        >
          <v-list-item-action>
            <v-icon>verified_user</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Kanal Yetkileri</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item :to="{ name: 'channel-add', query: { pid: channel.cid } }">
          <v-list-item-action>
            <v-icon>add</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Alt Kanal Oluştur</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item @click="confirmChannelDeletion(channel)">
          <v-list-item-action>
            <v-icon>delete</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Kanalı Sil</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>

    <v-dialog v-model="deleteChannelDialog" max-width="500px">
      <v-card>
        <v-card-title>Kanalı Sil</v-card-title>
        <v-card-text>
          Bu kanalı silmek istediğinize emin misiniz?
          <v-checkbox
            v-model="forceDeletion"
            label="Kanaldaki kullanıcılar olsa bile sil"
          ></v-checkbox>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="deleteChannel" color="primary">Evet</v-btn>
          <v-btn text @click="deleteChannelDialog = false" color="primary">
            Hayır
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// Bu componenti dinamik import ETME !!!
// Aksi halde görüntülenmez !!!
import Spacer from "@/components/Spacer";

export default {
  props: {
    channel: Object,
    queryUser: Object,
  },
  components: {
    Spacer,
  },
  data() {
    return {
      spacer: /^\[(.*)(spacer)(.*)\](.*)/,
      deleteChannelDialog: false,
      selectedChannel: {},
      forceDeletion: false,
      isDropHover: false,
    };
  },
  computed: {
    channelHoverTitle() {
      var ch = this.channel || {};
      var cid = ch.cid != null ? ch.cid : "";
      var pid = ch.pid != null ? ch.pid : "";
      return "CID: " + cid + "\nPID: " + pid;
    },
  },
  methods: {
    onDragOver(e) {
      e.dataTransfer.dropEffect = "move";
      this.isDropHover = true;
    },

    onDragLeave() {
      this.isDropHover = false;
    },

    async onDropClient(e) {
      this.isDropHover = false;

      let raw = "";
      try {
        raw = e.dataTransfer.getData("text/plain");
      } catch (_) {}

      let payload = null;
      try {
        payload = JSON.parse(raw);
      } catch (_) {}

      const clid = payload && Number(payload.clid);
      const targetCid = Number(this.channel && this.channel.cid);
      if (!clid || !targetCid) return;

      try {
        await this.$TeamSpeak.execute("clientmove", { clid, cid: targetCid });
        this.$toast && this.$toast.success("Kullanıcı taşındı");
      } catch (err) {
        this.$toast && this.$toast.error(err.message);
      }
    },

    // ✅ BUNU EKLE
    prettyChannelName(raw) {
      let s = String(raw || "");
      // lspacer etiketi baştaysa kırp
      s = s.replace(/^\s*\[lspacer[^\]]*\]\s*/i, "");
      return s;
    },

    isSpacer(channelName) {
      if (!channelName) return false;

      const name = String(channelName).toLowerCase();

      // ❌ lspacer normal kanal
      if (name.includes("[lspacer")) return false;

      // ✅ sadece cspacer/spacer
      return this.spacer.test(channelName) && this.channel.pid === "0";
    },

    confirmChannelDeletion(channel) {
      this.selectedChannel = { ...channel };
      this.deleteChannelDialog = true;
    },
    async deleteChannel() {
      let { cid } = this.selectedChannel;
      let force = +this.forceDeletion;

      try {
        await this.$TeamSpeak.execute("channeldelete", {
          cid: cid,
          force: force,
        });
      } catch (err) {
        this.$toast.error(err.message);
      }

      this.deleteChannelDialog = false;
    },
    moveClient() {
      return this.$TeamSpeak.execute("clientmove", {
        clid: this.queryUser.clientId,
        cid: this.channel.cid,
      });
    },
    async enterChannel() {
      try {
        await this.moveClient();
      } catch (err) {
        this.$toast.error(err.message);
      }
    },
    channelIconName(ch) {
      if (!ch) return "mdi-chat";

      // spacer ise ikon yok
      if (this.isSpacer && this.isSpacer(ch.channelName)) return "";

      var cid = Number(ch.cid || 0);
      var pid = Number(ch.pid || 0);

      // ✅ AFK KANALI
      if (this.afkCid && cid === Number(this.afkCid)) {
        return "mdi-sleep";
      }

      // 🔒 şifreli kanal (ES5 uyumlu)
      var hasPwRaw =
        ch && ch.channelFlagPassword != null
          ? ch.channelFlagPassword
          : ch && ch.channel_flag_password != null
          ? ch.channel_flag_password
          : 0;

      var hasPw = Number(hasPwRaw) === 1;

      if (hasPw) return "mdi-lock";
      if (pid > 0) return "mdi-hexagon-slice-4"; // alt kanal
      return "mdi-hexagon-slice-6"; // ana kanal
    },
  },
};
</script>

<style scoped>
* {
  text-transform: none !important;
}
.drop-hover {
  outline: 2px dashed rgba(255, 255, 255, 0.35);
  outline-offset: 2px;
}
/* Kanal satırları */
.v-treeview-node__root {
  min-height: 24px !important; /* default ~40px */
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

/* İçerik hizası */
.v-list-item {
  min-height: 24px !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
</style>
